import axios, { AxiosProgressEvent } from 'axios';

import {
  Command,
  CreateValues,
  DocumentTemplate,
  FindAllOptions,
  UpdateValues,
} from '../models/document/template';

import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions = {}): Promise<DocumentTemplate[]> {
    const url = this.common.constructPath(`/document-templates`, options);
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<DocumentTemplate> {
    const url = this.common.constructPath(`/document-templates/${id}`);
    return this.common.getJSON(url);
  }

  downloadURL(id: string): string {
    return this.common.constructPath(`/document-templates/${id}/file`);
  }

  async create(values: CreateValues): Promise<DocumentTemplate> {
    const url = this.common.constructPath(`/document-templates`);
    return this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<DocumentTemplate> {
    const url = this.common.constructPath(`/document-templates/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string) {
    const url = this.common.constructPath(`/document-templates/${id}`);
    return this.common.deleteJSON(url);
  }

  async getUploadURL(
    fileName: string,
  ): Promise<{ url: string; gsPath: string }> {
    const url = this.common.constructPath(`/document-templates/upload-url`, {
      fileName,
    });
    return await this.common.getJSON(url);
  }

  async upload(args: {
    file: File;
    url: string;
    progressHandler: (event: AxiosProgressEvent) => void;
  }): Promise<number> {
    const { file, url, progressHandler } = args;
    const res = await axios.put(url, file, {
      onUploadProgress: progressHandler,
      headers: { 'Content-Type': 'application/pdf' },
    });
    return res.status;
  }

  async preview(body: { gsPath: string; commands: Command[] }): Promise<Blob> {
    const url = this.common.constructPath(`/document-templates/preview`);
    const response = await this.common.authedFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) return response.blob();
    if (response.headers.get('Content-Type') === 'application/json') {
      const json = await response.json();
      throw new Error(json.message);
    }
    const text = await response.text();
    throw new Error(text);
  }

  async linkFormTemplate(args: {
    documentTemplateId: string;
    previsitFormTemplateId: string;
  }) {
    const url = this.common.constructPath(
      `/document-templates/${args.documentTemplateId}/form-template`,
    );
    await this.common.postJSON(url, {
      previsitFormTemplateId: args.previsitFormTemplateId,
    });
  }
}
